// DETAILS PAGE NAVIGATION, ELEMENT IDS

import {NavigationIdsMweb, navigationMenuNames} from '@stencil/hotels-types/src/details-constants';

// https://stackoverflow.com/a/52396706
const mirror = <V extends keyof any>(v: V) => v;

/**
 * @Note
 * this file was primarily meant to act as static values needed for
 * details navigation and filter screen names because of which see the comments below
 * -------------------------------------------------------------------------------------
 * @TODO
 * This can be changed to a better code with being less verbose after upgarding to TS 4.1+
 * Also Please Add the tabs in order
 */

/**
 * @TODO
 * all new screen names should be used from here, so that
 * it's easy to port all of them in a separate file finally
 */
export const srpFilterScreenNames = {
  hotelSearch: mirror('hotelSearch'),
};

const roomsListScreenRouteName = 'details-policy';
const aboutPropertyRouteName = 'about-property';

// @Note:- This is being used at HotelsInfo component, can be replaced with NavigationIdsMweb
export const rnrScreenRouteName = 'reviews';

export const routeToScreenMap = {
  [navigationMenuNames.amenities]: mirror(NavigationIdsMweb.detailAmenitiesInfo),
  [navigationMenuNames.rooms]: mirror(NavigationIdsMweb.pageListing),
  [navigationMenuNames.guestReviews]: mirror(rnrScreenRouteName),
  [navigationMenuNames.reviews]: mirror(rnrScreenRouteName),
  [navigationMenuNames.hotelPolicies]: mirror(NavigationIdsMweb.detailsPolicy),
  [navigationMenuNames.overview]: mirror(NavigationIdsMweb.overview),
  [navigationMenuNames.foodDining]: mirror(NavigationIdsMweb.foodAndDining),
  [navigationMenuNames.aboutProperty]: mirror(NavigationIdsMweb.aboutProperty),

  /** typescript not picking up dynamic values' styles in the index type below, hence
   * duplicatinng 'details-policy' and 'reviews'
   */
  // roomImagesGallery: mirror(`${roomsListScreenRouteName}/newroomdetails`),
  rnrImageGallery: mirror(NavigationIdsMweb.rnrGallery),
  dayUseRnrImageGallery: mirror(NavigationIdsMweb.dayUseRnrGallery),
  detailsGallery: mirror(NavigationIdsMweb.detailsGallery),

  roomImagesGallery: mirror(`page-listing/newroomdetails`),
  roomViewMore: mirror('newroomdetails'),
  [navigationMenuNames.filters]: mirror(NavigationIdsMweb.filters),
  [navigationMenuNames.maps]: mirror(NavigationIdsMweb.maps),

  foodAndDiningGallery: mirror(NavigationIdsMweb.fndGallery),

  /**
   * @TODO
   * srp screen names should live in a separate file
   * */
  [navigationMenuNames.locationFilters]: mirror(NavigationIdsMweb.locationFilters),
  [navigationMenuNames.location]: mirror(NavigationIdsMweb.location),
  [navigationMenuNames.hourlyFilterScreen]: mirror(NavigationIdsMweb.hourlyFilterScreen),
};

export const multiroomRoomOptionsContainer = 'multiroomRoomOptionsContainer';

export const navigationMenuNamesList = Object.values(navigationMenuNames);
export const allDetailsScreens = Object.values(routeToScreenMap);

export type NavigationMenuNamesType =
  (typeof navigationMenuNames)[keyof typeof navigationMenuNames];

export type ScreenNamesType = (typeof routeToScreenMap)[keyof typeof routeToScreenMap];

export const detailsNavigationIdsAndValues = {
  overview: {
    id: '#overview',
    value: navigationMenuNames.overview,
  },
  safetyHygiene: {
    id: '#safetyHygiene',
    value: navigationMenuNames.safetyHygiene,
  },
  goSafe: {
    id: '#go-safe',
    value: navigationMenuNames.goSafe,
  },
  rooms: {
    id: '#rooms',
    value: navigationMenuNames.rooms,
  },
  stays: {
    id: '#stays',
    value: navigationMenuNames.stays,
  },
  foodDining: {
    id: '#food-dining',
    value: navigationMenuNames.foodDining,
  },
  hostedBy: {
    id: '#hosted-by',
    value: navigationMenuNames.hostedBy,
  },
  amenities: {
    id: '#amenities',
    value: navigationMenuNames.amenities,
  },
  guestReviews: {
    id: '#guest-reviews',
    value: navigationMenuNames.guestReviews,
  },
  hotelPolicies: {
    id: '#hotel-policies',
    value: navigationMenuNames.hotelPolicies,
  },
  location: {
    id: '#location',
    value: navigationMenuNames.location,
  },
  aboutProperty: {
    id: '#about-property',
    value: navigationMenuNames.aboutProperty,
  },
  aboutArea: {
    id: '#about-area',
    value: navigationMenuNames.aboutProperty,
  },
  similarHotels: {
    id: '#similar-hotels',
    value: navigationMenuNames.similarHotels,
  },
  faqs: {
    id: '#faqs',
    value: navigationMenuNames.faqs,
  },
};

type DetailsNavigationIdsType = {
  [K in keyof typeof detailsNavigationIdsAndValues]: string;
};

/* for easy use when ids have to be set in markup, flatten the ids /*
/*  this function returns this  */
/**
 * {
 *    rooms: "rooms",
 *    amenities: "amenities"
 *    …
 * }
 */

export const detailsNavigationIds = Object.keys(detailsNavigationIdsAndValues).reduce(
  (idsAccumulator, currentKey) => {
    return {
      ...idsAccumulator,
      [currentKey]: detailsNavigationIdsAndValues[currentKey].id.replace('#', ''),
    };
  },
  {} as DetailsNavigationIdsType,
);

export const getDetailsNavigationIdsAndValuesObjectById = (id: string) => {
  const key = Object.keys(detailsNavigationIdsAndValues).filter(key => {
    return detailsNavigationIdsAndValues[key].id === id;
  })[0];

  const value = detailsNavigationIdsAndValues[key];

  return value;
};

export const componentIds = {
  tripAdvisor: '#GiTripAdvsior',
};
